export default __webpack_public_path__ + "static/media/background.403c5085.mp4";